import React, { memo } from 'react';

type TProps = {
  color: string;
  useTwoColors?: boolean;
  isMobile?: boolean;
};

export const ColourCircle: React.FC<TProps> = memo(
  ({ color, useTwoColors = true, isMobile = false }: TProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
      {useTwoColors && <rect x="0.0605469" width="20" height="20" rx="10" fill="#BCC19C" />}
      <rect x="0.0605469" width="20" height="20" rx="10" fill={color} />
      <rect
        x="0.0605469"
        width="20"
        height="20"
        rx="10"
        fill={isMobile ? 'url(#paint0_radial_3008_61878_mobile)' : 'url(#paint0_radial_3008_61878)'}
      />
      <defs>
        <radialGradient
          id={isMobile ? 'paint0_radial_3008_61878_mobile' : 'paint0_radial_3008_61878'}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(10.0605 10) rotate(90) scale(10)">
          <stop offset="0.630208" stopOpacity="0" />
          <stop offset="1" stopOpacity="0.15" />
        </radialGradient>
      </defs>
    </svg>
  )
);
